import { Component, Input } from "@angular/core";
import { FormGroup } from "@angular/forms";

import { FormToolsService } from "@atenea-cms";

@Component({
  selector: "product-sub-spec-form",
  templateUrl: "./product-sub-spec-form.component.html",
  styleUrls: ["./product-sub-spec-form.component.scss"],
})
export class ProductSubSpecFormComponent {
  @Input() form: FormGroup;

  constructor(public ft: FormToolsService) {}
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/products/product-sub-spec-form/product-sub-spec-form.component.ts